import React from 'react';

interface GameTitleProps {
    title: string;
    subtitle?: string;
}

const GameTitle: React.FC<GameTitleProps> = ({ title, subtitle }) => {
    return (
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <h1 style={{
                color: '#FFFF00',
                fontSize: '36px',
                margin: '10px 0',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
            }}>
                {title}
            </h1>
            {subtitle && (
                <div style={{
                    color: '#FFFFFF',
                    fontSize: '16px',
                    marginTop: '5px'
                }}>
                    {subtitle}
                </div>
            )}
        </div>
    );
};

export default GameTitle; 